import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationServices } from '../../../appauth/notification/notificatio.services';
import { CustomValidators } from 'ng2-validation';
import { FotoClientesServices } from '../fotocliente/fotoclientes.services';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
	selector: 'app-add-foto-cliente',
	templateUrl: './fotocliente.compente.html',
	styleUrls: ['./fotocliente.compente.scss']
})

export class FotoClientesComponent implements OnInit {
    
	constructor(private fb: FormBuilder,
        private servicioFotoClientes:FotoClientesServices,
        public dialogRef: MatDialogRef <FotoClientesComponent>,
        @Inject(MAT_DIALOG_DATA) public Cliente: any,
		private Noti:NotificationServices,) { }

	ngOnInit() {
		console.log(this.Cliente);
        
	}


	onFileChange(event) {
    if(event.target.files.length > 0) {
        var file = event.target.files[0];
        var formData = new FormData();
        
        formData.append('filename', file);
        formData.append('cliente_id',this.Cliente.id);
        
        this.servicioFotoClientes.saveFotoCliente(formData).subscribe((data:any)=>{
        if(data.estado){
            this.Noti.setNotification(data).then((datas)=>{
                if(datas){
                    this.dialogRef.close(1);
                }
            }); 
            
        }else{
            this.Noti.setNotification(data);
        }
        });
    }
    }

}